import React, { useState, useRef } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/ClassThree/SocialStudies";

const SocialStudies: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    document.title = "Mamas Guidance - Class Three - Social Studies"; // Set page title

    return (
        <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};
export default SocialStudies;